import {classnames} from '@@client/lib/classes'
import OneCol from './OneCol'

export default function Col100({children, className}) {
    return (
        <OneCol className={classnames(className, 'col100')}>
            {children}
        </OneCol>
    )
}
